import {Appearance, StyleSheet} from 'react-native';

export enum WhiteColor {
  textColor = '#051A3A',
  linkColor = '#1A67DB',
  focusColor = '#1A67DB',
  whiteColor = '#FFFFFF',
  grayColor = '#C4C5CE',
  mainColor = '#051A3A',
  mainColorSpace = '#0772BA',
  bordercolor = '#e0e0e0',
  disableColor = '#E9EAEF',
  greenColor = '#00BC08',
  redColor = '#FF0000',
  growColor = '#00BC08',
  yellowColor = '#FEE005',
  spaceColor = '#F6F6F6',
  blue = '#0772BA',
  red = 'red',
  bgtime = '#F6F6F6',
  bordercolorBox = '#F6F6F6',
  gray = 'gray',
  gray2x = 'rgba(0,0,0,0.3)',
  gray3x = '#e0e0e0',
  green = '#00BC08',
  black = '#000000',
  white = '#ffffff',
  placeHoderColor = '#888888',
  transparentLoading = 'rgba(0,0,0,0.2)',
  transparent = 'transparent',
}

export const Ecolors =
  Appearance.getColorScheme() === 'dark' ? WhiteColor : WhiteColor;

export enum Efonts {
  bold = 'Roboto-Bold',
  medium = 'Roboto',
  italic = 'Roboto-Italic',
}

export const EStyle = StyleSheet.create({
  shadow: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
  },
  shadowItem: {
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 0,
    //   height: 1,
    // },
    // shadowOpacity: 0.2,
    // shadowRadius: 1.41,
    // elevation: 2,
  },
});
